var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeeds2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 4H7.2C6.08 4 5.52 4 5.092 4.218C4.71565 4.40969 4.40969 4.71565 4.218 5.092C4 5.52 4 6.08 4 7.2V16.8C4 17.92 4 18.48 4.218 18.908C4.40974 19.2843 4.71569 19.5903 5.092 19.782C5.519 20 6.079 20 7.197 20H16.803C17.921 20 18.48 20 18.907 19.782C19.284 19.59 19.59 19.284 19.782 18.908C20 18.48 20 17.921 20 16.803V16.2M10 14H13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_5421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3497 12.75L19.0497 9.45004M12.4497 6.70004C12.4497 7.20563 12.5493 7.70627 12.7428 8.17337C12.9363 8.64047 13.2198 9.06489 13.5773 9.4224C13.9349 9.7799 14.3593 10.0635 14.8264 10.257C15.2935 10.4505 15.7941 10.55 16.2997 10.55C16.8053 10.55 17.3059 10.4505 17.773 10.257C18.2401 10.0635 18.6646 9.7799 19.0221 9.4224C19.3796 9.06489 19.6632 8.64047 19.8566 8.17337C20.0501 7.70627 20.1497 7.20563 20.1497 6.70004C20.1497 6.19445 20.0501 5.69381 19.8566 5.22671C19.6632 4.7596 19.3796 4.33518 19.0221 3.97768C18.6646 3.62017 18.2401 3.33658 17.773 3.1431C17.3059 2.94962 16.8053 2.85004 16.2997 2.85004C15.7941 2.85004 15.2935 2.94962 14.8264 3.1431C14.3593 3.33658 13.9349 3.62017 13.5773 3.97768C13.2198 4.33518 12.9363 4.7596 12.7428 5.22671C12.5493 5.69381 12.4497 6.19445 12.4497 6.70004Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_5421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2,
    height: 13.2,
    fill: "white",
    transform: "translate(10.7998 1.20001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeeds2);
export default __webpack_public_path__ + "static/media/needs2.9c0782b4e396979f2ebc861eba1d1a73.svg";
export { ForwardRef as ReactComponent };